import { ToolSearchParams } from 'src/app/shared/models/toolSearchParams';

export enum AssignmentGroups {
  AssignedToJob = 'Assigned to job',
  AssignedToEmployee = 'Assigned to employee',
  AssignedToShop = 'Assigned to shop',
  OutForRepair = 'Out for repair',
  Other = 'Other',
}
export interface JobModel {
  id?: number;
  name: string;
  potentialJobDetail?: object;
}

export interface AutoCompleteSelectModel {
  item: any;
  id: string;
}

export interface OwnerModel {
  id?: number;
  ownerName: string;
}

export interface FacilityModel {
  id?: number;
  facilityName: string;
}

export interface UserModel {
  id?: number;
  employeeAlias: string;
}

export interface AssignmentTypeModel {
  id?: number;
  name: string;
  group: string;
}

export interface AssignmentModel {
  type: AssignmentTypeModel;
  primaryAssignment: string;
}

export interface SelectedDataModel {
  id: number | string;
  tool?: {
    id: number
    toolId: number
    assignment?: Array<AssignmentModel>;
  }
  toolId: number;
  description: string;
  selected?: boolean;
  toolInventoryId?: number;
  toolInventoryJunctionId?: number | string;
}

export interface PaginationModel {
  currentPage: number;
  totalPages: number;
  nextPage: number;
}

export interface ResponseModel {
  data: any;
  pagination: PaginationModel;
}

export interface InventoryTransferModel {
  toolId: number;
  assignedDate: string;
  typeId?: number;
  jobId?: number;
  ownerId?: number;
  facilityId?: number;
  responsiblePartyId?: number;
  employeeId?: number;
  vendorId?: number;
  shopId?: number;
  notes?: string;
}

export interface TransferModelData {
  key: string;
  value: string | number;
}

export const UserParams: ToolSearchParams = {
  search: '',
  page: 1,
  limit: 25,
  attributes: 'id,firstName,lastName,employeeAlias',
  'scope[status]': 1,
  order: 'employeeAlias,ASC',
};

export const JobParams: ToolSearchParams = {
  search: '',
  page: 1,
  limit: 25,
  attributes: 'id,jobNumber,name',
  embed: 'potentialJobDetail',
  order: 'jobNumber,DESC',
};

export const OwnerParams: ToolSearchParams = {
  search: '',
  page: 1,
  limit: 25,
  attributes: 'id,ownerName',
  order: 'ownerName,ASC',
};

export const FacilityParams: ToolSearchParams = {
  search: '',
  page: 1,
  limit: 25,
  attributes: 'id,ownerId,facilityName',
  order: 'facilityName,ASC',
};

export const ShopParams: ToolSearchParams = {
  search: '',
  page: 1,
  limit: 25,
  attributes: 'id,name',
  order: 'name,ASC',
  filter: 'enabled=1',
};

export const VendorParams: ToolSearchParams = {
  search: '',
  page: 1,
  limit: 25,
  attributes: 'id,companyName',
  order: 'companyName,ASC',
};

export const AssignmentTypeParams: ToolSearchParams = {
  search: 'Other',
  page: 1,
  limit: 25,
  fields: 'group',
  attributes: 'id,name,group',
};

export const ParamsMappingForTransfer = [
  {
    name: 'jobs',
    param: JobParams,
  },
  {
    name: 'owners',
    param: OwnerParams,
  },
  {
    name: 'facilities',
    param: FacilityParams,
  },
  {
    name: 'users',
    param: UserParams,
  },
  {
    name: 'shops',
    param: ShopParams,
  },
  {
    name: 'vendors',
    param: VendorParams,
  },
];
